import React from 'react';
// import { TablePagination } from '@material-ui/core';


export default class NotFound extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            some: ''
        }
    }
    render() {
        return (
            <div className="text-center dashboard-cover -4" style={{ backgroundColor: "#eff3f7", zIndex: '0',}}>
                <div className="header-dashboard" style={{marginTop: '10%', fontSize: '100px', color: '#FF7229' }}>
                    404
              </div>
              <div style={{fontSize: '40px', color: 'black', fontWeight: 'bold', marginBottom: '2%'}}>Oops! Page not found</div>
                <div className="Subheading-dashboard slideInOut animated">Sorry, but the page you are looking for is not found. Please, contact support for further clarification.
              </div>
              {/* <TablePagination /> */}
            </div>
        );
    }
}
